

export default {
  SET_NBRE_CLIENT (state, data) {
    state.nombre_client = data
  },
  SET_NBRE_GENRE_CLIENT (state, data) {
    state.nombre_genre_client = data
  }
}